import React, { FC } from 'react'
import { graphql } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import Layout from '../components/layout'
import SEO from '../components/seo'
import { getGatsbyImage } from '../helpers/processImages'
import { AllFileQueryI, MarkdownQueryI } from '../types/common'
import { SiteMetadataI, PostI } from '../types/data-models'

interface BlogPostTemplateI {
  data: {
    site: {
      siteMetadata: SiteMetadataI
    }
    post: MarkdownQueryI<PostI>
    location: Location
    thumbnails: AllFileQueryI
  }
}
const BlogPostTemplate: FC<BlogPostTemplateI> = ({
  data: {
    post,
    site: {
      siteMetadata: { title },
    },
    thumbnails,
    location,
  },
}) => (
  <Layout location={location} title={title}>
    <SEO title={post.frontmatter.title} description={post.frontmatter.description || post.excerpt} />
    <article className={`post-content ${(post.frontmatter.thumbnail && post.frontmatter.thumbnail.url) || `no-image`}`}>
      <header className="post-content-header">
        <h1 className="post-content-title">{post.frontmatter.title}</h1>
      </header>

      {post.frontmatter.description && <p className="post-content-excerpt">{post.frontmatter.description}</p>}

      {post.frontmatter.thumbnail && post.frontmatter.thumbnail.url && (
        <div className="post-content-image">
          {post.frontmatter.thumbnail?.url && (
            <GatsbyImage
              className="kg-image"
              image={getGatsbyImage(post.frontmatter.thumbnail?.url, thumbnails)}
              alt={post.frontmatter.thumbnail.label || post.frontmatter.title}
            />
          )}
        </div>
      )}

      {post.html && <div className="post-content-body" dangerouslySetInnerHTML={{ __html: post.html }} />}

      <footer className="post-content-footer">
        {/* There are two options for how we display the byline/author-info.
        If the post has more than one author, we load a specific template
        from includes/byline-multiple.hbs, otherwise, we just use the
        default byline. */}
      </footer>
    </article>
  </Layout>
)

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    post: markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        thumbnail {
          url
          label
        }
      }
    }
    thumbnails: allFile(filter: { sourceInstanceName: { eq: "images" } }) {
      edges {
        node {
          relativePath
          sourceInstanceName
          childImageSharp {
            gatsbyImageData(width: 1360, quality: 100, placeholder: BLURRED)
          }
          publicURL
        }
      }
    }
  }
`
